export default (store,form)=>{
    return store.form[form];
}